export default __webpack_public_path__ + "static/media/divider.3fde5278.svg";